<template>
  <div class="warpper">
    <div class="warpper_reply">

      <div class="reply_header line_bottom">
          <div class="d-flex">
              <span>状态</span>
              <p class="title">{{list.title}}</p>
          </div>
          <div class="d-flex">
              <span>进入时间：</span>
              <p>{{list.planTime | filtTime}}</p>
          </div>
      </div>

      <div class="object">
          <div class="title">
              复核对象信息
          </div>
          <div class="d-flex" style="position: relative" @click="goCompany(list.enterpriseId)">
              <span class="span">企业名称：</span>
              <p class="p d-flex justify-content-bettwen">{{list.name}}<img class="img1" src="../../assets/image/inner_icon_select.png"/></p>
          </div>
          <div class="d-flex">
              <span class="span">行政区域：</span>
              <p class="p">{{list.regionName}}</p>
          </div>
          <div class="d-flex">
              <span class="span">异常类别：</span>
              <p class="p" style="color: red">{{list.taskType == 21 ? '企业停业' : '经营范围变更' }}</p>
          </div>
          <hr>
          <div class="d-flex info" @click="goOrder(list.orderId)">工单详情<img src="../../assets/image/tb-right.png"/></div>
      </div>

        <div class="text">
            <div class="title">审核意见</div>
            <div class="content">
                <textarea v-if="list.isHandle" disabled placeholder="请输入审核意见" class="txt" v-model="list.memo"></textarea>
                <textarea v-if="!list.isHandle" placeholder="请输入审核意见" class="txt" v-model="reason"></textarea>
            </div>
        </div>
        <div class="d-flex justify-content-bettwen bottom" v-if="!list.isHandle">
            <div class="btn" @click="rejected">复核不通过</div>
            <div class="btn pass" @click="pass">复核通过</div>
        </div>
    </div>
  </div>
</template>
<script>
    import api from '../../service/modules/integrity'
    import util from '@/utils/common';
    import moment from "moment";
    export default {
        name: 'todoDetails',
        data () {
            return {
                list: {},
                reason: '',
                isCommit: false,
                typeListAll: []
            }
        },
        filters: {
            filtTime(value) {
                return moment(value).format("YYYY-MM-DD HH:mm:ss");
            },
        },
        computed: {
        },
        created () {
            
            this.taskDetails();
            this.getindustryCategory()
            
        },
        // beforeCreate () {
        //     this.list = util.removeJsonLocal('item')
        // },
        mounted () {
        },
        methods: {
            taskDetails() {
                
                api.taskDetails2({
                    id: this.$route.query.id
                }).then(res =>{
                    console.log(res)
                    this.list = res.data;
                    console.log(this.list.industryCategory.slice(1, -1))
                })
            },
 
            pass() {
                let params;
                if (this.list.taskType == 22) {
                    params = {
                        auditId: this.$route.query.taskId,
                        reason: this.reason,
                        industryCategory: this.typeListAll.filter(item => this.list.industryCategory.slice(1, -1) === item.name)[0].code
                    }
                } else {
                    params = {
                        auditId: this.$route.query.taskId,
                        reason: this.reason,
                    }
                }
                // return console.log(params)
                api.pass(params).then(res => {
                    console.log(res)
                    if (res.ret == 0) {
                        // this.$toast('审核已提交');
                        this.reason = '';
                        // this.taskDetails()
                        yyn.invokeJSB('closeWindow');
                        this.$Toast({
                            message: '处理成功',
                            icon: 'passed'
                        });
                        // this.isCommit = true;
                     }
                })
            },
            goCompany (enterpriseId) {
                this.$router.push({
                    path: '/integrity/enterpriseDetail',
                    query: {
                        enterpriseId
                    }
                })
            },
            goOrder(id) {
                this.$router.push({
                    path: '/integrity/workOrder',
                    query: {
                        enterpriseId: id
                    }
                })
            },
            rejected() {
                let params;
                if (this.list.taskType == 22) {
                    params = {
                        auditId: this.$route.query.taskId,
                        reason: this.reason,
                        industryCategory: this.typeListAll.filter(item => this.list.industryCategory.slice(1, -1) === item.name)[0].code
                    }
                } else {
                    params = {
                        auditId: this.$route.query.taskId,
                        reason: this.reason,
                    }
                }
                // return console.log(params)
                api.rejected(params).then (res => {
                    console.log(res)
                    if (res.ret == 0) {
                        // this.$toast('审核已提交');
                        
                        this.reason = '';
                        
                    // this.taskDetails()
                    yyn.invokeJSB('closeWindow');
                    this.$Toast({
                            message: '处理成功',
                            icon: 'passed'
                        });
                        // this.isCommit = true;
                     }
                    
                })
            },
            getindustryCategory () {
                api.industryCategory().then(res => {
                if (res.ret === 0) {
                    this.typeListAll = res.data;
                    }
                });
            },
        }
    }
</script>
<style lang="less" scoped>
.warpper {
  background: #F5F6F9;
  height: 100%;
  position: relative;
  .warpper_reply {
    padding: 24px 12px;
    .d-flex {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        &:last-of-type {
            margin-bottom: 0;
        }
    }
    .justify-content-bettwen {
        justify-content: space-between;
    }
    .span {
        color: #666666;
    }
    .p {
        color: #333333;
    }
    .title {
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: #333333;
    }
    img {
        width: 8px;
        height: 8px;
    }
    .reply_header {
        background-color: #fff;
        padding: 15px 20px 12px;
        border-radius: 3px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
        .d-flex {
            span, p {
                color: #666666;
            }
            &:first-of-type {
                margin-bottom: 8px;
                span {
                    padding: 2px;
                    background-color: #36B374;
                    text-align: center;
                    line-height: 16px;
                    margin-right: 3px;
                    color: #fff;
                    font-size: 10px;
                    border-radius: 1px;
                }
                p {
                    color: #333333;
                    font-size: 16px;
                }
            }
        }
    }
    .object {
        margin-top: 12px;
        margin-bottom: 12px;
        background: #FFFFFF;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        padding: 12px 20px;
        .title {
            margin-bottom: 12px;
        }
        hr {
            border-top: 1px solid #eee;
            margin: 12px 0;
        }
        .info {
            color: #36B374;
            font-size: 12px;
        }
        .img1 {
            position: absolute;
            right: 20px;
            top: 50%;
            margin-top: -4px;
        }
        .img {
            margin-left: 8px;
        }
    }
    
    .text {
        background: #fff;
        padding: 12px 20px 20px;
        height: 100%;
        .content{
            width:100%;
            height:180px;
            margin-top: 12px;
            .txt{
                width:100%;
                height:100%;
                border: 0;
                outline:none;
                resize: none;
                background-color: #F9F9F9;
                padding:16px;
                font-size: 14px;
                box-sizing: border-box;
            }
        }
    }
    .bottom {
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        padding: 15px 15px 31px;
        .btn {
            width: 165px;
            height: 40px;
            border: 1px solid #36B374;
            border-radius: 3px;
            text-align: center;
            line-height: 40px;
            color: #36B374;
            font-size: 16px;
        }
        .pass {
            margin-left: 15px;
            color: #fff;
            background-color: #36B374;
        }
    }
  }
}
</style>
